import React from 'react';
import Header from '../sections/Header';
import Banner from '../sections/Banner';
import Footer from '../sections/Footer';
import InitiativeOneSection from '../sections/InitiativeOneSection';
import InitiativeTwoSection from '../sections/InitiativeTwoSection';
import InitiativeThreeSection from '../sections/InitiativeThreeSection';
import InitiativeFourSection from '../sections/InitiativeFourSection';

const Home: React.FC = () => {
  return (
    <>
      <Header />
      <Banner
        title={
          <>
            Welcome to <span style={{ color: '#2dd4bf' }}>AI Lab</span>, our firm wide program to invest in AI initiatives, workflows, training and tools.
          </>
        }
        subtitle="We've created this destination at The Hub, so you can follow, engage and contribute to the various initiatives we're investing in, that make sense for you."
        icon={
          <div className="flex items-center justify-center">
            <img src="/logos/Banner-Home.svg" alt="AI Lab Banner" className="w-120 h-120 object-contain" />
          </div>
        }
        colorVariant="gradient"
        imageVariant="withImage"
        paddingVariant="default"
        showCTAs={true}
        showDefaultGraphic={true}
      />

      <InitiativeOneSection />
      <InitiativeTwoSection />
      <InitiativeThreeSection />
      <InitiativeFourSection />
      <Footer />
    </>
  );
};

export default Home;
